import {SmileyIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import {graphql, useFragment} from 'react-relay'

import type {Reactions$key} from './__generated__/Reactions.graphql'
import styles from './Reactions.module.css'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const ReactionsFragment = graphql`
  fragment Reactions on Reactable {
    reactionGroups {
      content
      reactors {
        totalCount
      }
    }
  }
`

type Props = {
  dataKey: Reactions$key
  reactionEmojiToDisplay?: {reaction: string; reactionEmoji: string}
  showCompactDensity?: boolean
}

export const Reactions = ({dataKey, reactionEmojiToDisplay, showCompactDensity = false}: Props) => {
  const data = useFragment(ReactionsFragment, dataKey)

  let totalReactionCount: number
  if (reactionEmojiToDisplay) {
    totalReactionCount =
      data.reactionGroups?.filter(e => e.content === reactionEmojiToDisplay.reaction)[0]?.reactors.totalCount || 0
  } else {
    totalReactionCount = data.reactionGroups?.reduce((sum, g) => sum + (g.reactors.totalCount || 0), 0) || 0
  }

  if (totalReactionCount === 0) {
    return null
  }

  return (
    <div className={clsx(styles.reactionsContainer, showCompactDensity && styles.compactDensity)}>
      <>
        {reactionEmojiToDisplay ? <span>{reactionEmojiToDisplay.reactionEmoji}</span> : <SmileyIcon size={16} />}
        <span>{totalReactionCount}</span>
      </>
    </div>
  )
}
